import React from 'react';
import '../template-file-css/document-file-template.css';


export const CBS_FaxCoverSheetUnitedHealthcare = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CBS_FaxCoverSheetUnitedHealthcare' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <b>
                            CBS ACT Center, LLC
                            <br/>
                            FAX COVER SHEET
                        </b>
                    </center> 

                </p>

                <table>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>RE:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>To:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRE' name='txtRE' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTo' name='txtTo' className='add-only' defaultValue={'United Healthcare'} /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFax' name='txtFax' className='add-only' defaultValue={'1-337-475-8054'} /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Total Number of Pages (Including This Cover Sheet):</span> </td>
                        <td className='w-375'> <span className='eleHeader'>From:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPages' name='txtPages' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFrom' name='txtFrom' className='add-only' defaultValue={'Jennifer Brown, LPC'} /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Company Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Ref:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCompany' name='txtCompany' className='add-only' defaultValue={'CBS ACT Center, LLC'} /> </td>
                        <td className='w-375'> <input type='text' id='txtRef' name='txtRef' className='add-only' defaultValue={'Prior Authorization Request'} /> </td>
                    </tr>
                </table>



                <p className='w-750'>
                    <b>PRIVACY AND CONFIDENTIALITY WARNING</b>
                    <br/>

                    This fax may contain Protected Health Information, Individually Identifiable Health Information and
                    other information, which is protected by law. The information is intended only for the use of the
                    intended recipient. If you are not the intended recipient, you are hereby notified that any review,
                    disclosure/re-disclosure, copying, storing, distributing or the taking of action in reliance on the content
                    of this fax and any attachments thereto, is strictly prohibited. If you have received this fax in error,
                    please notify the sender immediately and destroy the contents of this fax and its attachments by deleting
                    any and all electronic copies and any and all hard copies regardless of where they are maintained or
                    stored. 
                </p>

                <p className='w-750'>  
                    Where we provide Quality Services for our clients!
                    Tel: 318-226-5990 Fax: 318-226-5994
                </p>



            </div>
        </form>

    )
}











